<div class="flex items-center justify-between gap-3 flex-wrap">
  <input
    type="text"
    [placeholder]="searchPlaceholder"
    class="kt-input sm:w-72"
    [attr.data-kt-datatable-search]="'#' + datatableId"
  />

  <div class="inline-flex items-center gap-2">
    <button type="button" class="kt-btn kt-btn-sm" [attr.data-kt-modal-toggle]="'#' + addModalId">
      <i class="ki-filled ki-plus text-sm" aria-hidden="true"></i>
      <span>{{ addButtonLabel }}</span>
    </button>

    <button
      type="button"
      class="kt-btn kt-btn-outline kt-btn-icon"
      [attr.aria-label]="refreshAriaLabel"
      (click)="refresh.emit()"
      [disabled]="disableRefresh"
    >
      <i class="ki-filled ki-arrows-circle"></i>
    </button>
  </div>
</div>
